<template>
  <div class="voicemail">
    <div class="voicemail__info">
      <div class="flex align-center">
        <status-indicator
          v-if="voicemail.status === 'unread'"
          status="active"
        />
        <div v-else style="width: 10px; height: 10px;"></div>
        <h3 class="black-text mt-0 mb-0 ml-10">
          <strong>{{ voicemail.callerName }}</strong>
        </h3>
      </div>

      <p class="mt-0 mb-0 ml-20 black-text">
        {{ numberFormatter(voicemail.callerNumber) }}
      </p>
    </div>
    <div class="voicemail__actions">
      <div class="time">
        <h3 class="black-text">{{ voicemail.vmDay }}</h3>
        <p class="black-text">{{ voicemail.vmTime }}</p>
      </div>

      <el-button
        type="primary"
        class="mr-0"
        circle
        icon="el-icon-caret-right"
        @click="playMessage"
      />

      <el-button
        type="danger"
        class="mr-0"
        circle
        icon="el-icon-delete"
        @click="deleteMessage"
      >
      </el-button>
    </div>
  </div>
</template>

<script>
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: "VoxoMobileVoicemailCell",

  props: {
    voicemail: {
      required: true,
    },
  },

  methods: {
    playMessage() {
      this.$emit("playOperation", this.voicemail);
    },

    deleteMessage() {
      this.$emit("deleteOperation", this.voicemail.id);
    },

    numberFormatter(number) {
      return number
        ? phoneNumberFormatter(number)
        : number;
    },
  },
};
</script>

<style lang="scss" scoped>
.voicemail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;

  &__info {
    h3 {
      font-weight: normal;
    }
  }

  &:not(:last-child) {
    border-bottom: solid 2px #eee;
  }

  &__actions {
    display: flex;
    align-items: center;

    & .time {
      margin-right: 20px;

      & > * {
        margin: 0;
      }
    }
  }
}
</style>
